type T_res = [lat: number, lon: number] | null;

export const geocodeAddress = async (address: string): Promise<T_res> => {
  const res = await fetch(
    `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
      address
    )}`
  );
  const data = await res.json();
  const result = data[0];

  if (result) {
    return [parseFloat(result.lat), parseFloat(result.lon)];
  }

  return null;
};
